import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import useSiteCopySelector from 'components/useSiteCopySelector';
// import GoodEvidenceIcon from '../../images/one.svg';
// import SomeEvidenceIcon from '../../images/two.svg';
// import InsufficientIcon from '../../images/three.svg';

const styles = theme => ({
  root: {
    maxWidth: 400,
    borderRadius: 0,
    opacity: '1 !important',
    padding: '30px 18px 20px',
    [theme.breakpoints.down('400px')]: {
      maxWidth: 300,
    },
  },
  rootContent: {
    flex: '1 1 auto',
  },
  inline: {
    display: 'inline',
    marginLeft: 15,
  },
  noMargin: {
    marginLeft: 0,
  },
  content: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginBottom: 10,
    flex: '1 1 auto',
  },
  info: {
    // marginLeft: 21,
  },
  title: {
    fontSize: 16,
    fontFamily: 'PoppinsSemiBold',
    lineHeight: '21px',
  },
  description: {
    fontSize: 12,
    lineHeight: '16px',
  },
  iconTooltip: {
    marginRight: 20,
    width: 24,
    height: 24,
  },
  icon: {
    width: 16,
    height: 16,
    borderRadius: 8,
    marginRight: 16,
    marginTop: 4,
    display: 'inline-block',
  },
});

function EvidenceTooltip(props) {
  const [toolTipData] = useSiteCopySelector(['tooltip']);
  let toolTipValues;

  if (!_isEmpty(toolTipData)) {
    toolTipValues = _get(toolTipData, 'pageCopy', {});
  }
  const { tooltipId, children, classes, position, removeMargin } = props;
  const contentData = [
    {
      name: _get(toolTipValues, ['labels', 'Good Evidence']),
      description: _get(toolTipValues, 'Good Evidence', ''),
      iconColor: '#20D1AC',
    },
    {
      name: _get(toolTipValues, ['labels', 'Some Evidence']),
      description: _get(toolTipValues, 'Some Evidence', ''),
      iconColor: '#0BA6C2',
    },
    {
      name: _get(toolTipValues, ['labels', 'Good Idea']),
      description: _get(toolTipValues, 'Insufficient Evidence', ''),
      iconColor: '#136369',
    },
  ];
  return (
    <div
      className={_classNames({
        [classes.inline]: true,
        [classes.noMargin]: removeMargin,
      })}
    >
      <ReactTooltip
        id={`${tooltipId}`}
        place={position}
        type="light"
        effect="solid"
        className={classes.root}
        border
        afterShow={props.onShow}
      >
        <Grid container direction="column" className={classes.rootContent}>
          {contentData.map(({ name, iconColor, description }) => (
            <Grid item xs={12} className={classes.content} key={name}>
              <div>
                <span
                  className={classes.icon}
                  style={{ backgroundColor: iconColor }}
                />
              </div>

              <div className={classes.info}>
                <Typography className={classes.title}>{name}</Typography>
                <Typography className={classes.description}>
                  {description}
                </Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      </ReactTooltip>
      <div
        data-tip
        data-for={!_isEmpty(toolTipValues) && tooltipId}
        className={_classNames({
          [classes.inline]: true,
          [classes.noMargin]: removeMargin,
        })}
      >
        {children}
      </div>
    </div>
  );
}

EvidenceTooltip.propTypes = {
  tooltipId: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.object,
  position: PropTypes.string,
  removeMargin: PropTypes.bool,
  onShow: PropTypes.func,
};

EvidenceTooltip.defaultProps = {
  position: 'bottom',
  removeMargin: false,
};

export default withStyles(styles)(EvidenceTooltip);
